<script>
  import { slide } from 'svelte/transition';
  // onMount non è utilizzato in questo specifico snippet, ma lo lascio se serve per altro
  import { onMount } from 'svelte'; 
  
  let services = [
    { 
      icon: 'MAniCUoreFiori.png', 
      title: 'SOSTEGNO PSICOLOGICO', 
      description: 'Percorsi di sostegno psicologico rivolti ad adulti, giovani adulti, adolescenti.' 
    },
    { 
      icon: 'Cerotto.png', 
      title: 'AREE DI INTERVENTO', 
      description: 'Disturbi d’ansia, attacchi di panico, depressione, ansia sociale, disturbi dell’umore, fobia specifica, ipocondria, disturbi psicosomatici, insonnia, stress, affettività, autostima, difficoltà relazionali ed emotive, benessere psicologico, crescita personale.' 
    },
    { 
      icon: 'ImgSOleCArino.png', 
      title: 'MINDFULNESS', 
      description: 'All’interno del mio approccio integro mindfulness e tecniche di rilassamento per ridurre stress e ansia. La mindfulness è una pratica che consiste nel portare l\'attenzione e la consapevolezza al momento presente in maniera non giudicante.' 
    },
    { 
      icon: 'farfallaCarina.png', 
      title: 'ALTA SENSIBILITÀ', // Nota: il titolo originale era senza apostrofo, mantengo coerenza
      description: 'Riconoscimento e gestione dell\'alta sensibilità, tratto che definisce una capacità più profonda di elaborazione delle informazioni sensoriali. PAS (Persone Altamente Sensibili).' 
    }
  ];
  
  let activeServiceIndex = null;
  
  function toggleService(index) {
    activeServiceIndex = activeServiceIndex === index ? null : index;
  }
</script>


<svelte:head>
  <title>I miei servizi - Dott.ssa Eleonora Ceroni Psicologa Faenza</title>
  <meta name="description" content="Sono la Dott.ssa Eleonora Ceroni, mi occupo di alta sensibilità, mindfulness, sostegno psicologico, disturbi d'ansia, affettività, stress." />
  
</svelte:head>

<section id="servizi" class="services">
  <h2>SERVIZI</h2>
  <div class="service-grid">
    {#each services as service, i}
      <div 
        class="service-item" 
        class:active={activeServiceIndex === i}
        on:click={() => toggleService(i)}
        role="button" 
        tabindex="0"
        on:keydown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleService(i) }}
        aria-expanded={activeServiceIndex === i}
        aria-controls="description-{i}"
      >
        <div class="service-icon">
          <img src={service.icon} alt="" />
        </div>
        <h3>{service.title}</h3>
        {#if activeServiceIndex === i}
          <p class="description" transition:slide|local id="description-{i}">
            {service.description}
          </p>
        {/if}
      </div>
    {/each}
  </div>
</section>

<style>
  .services {
    padding: 1rem 2rem;
    background-color: rgba(231,207,194,0.4);/*#ADCAB2;*/
    margin: 2rem 0;
    border-radius: 10px;
  }
  
  .service-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    align-items: start; 
margin-bottom: 2rem;
  }
  
  .service-item {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 1.5rem;
    text-align: center;
    transition: box-shadow 0.3s ease;
    cursor: pointer;
    height: fit-content; /* Per evitare che tutti i box abbiano la stessa altezza quando uno si espande */
  }
  
  .service-item:hover, .service-item:focus-visible { /* Aggiunto focus-visible per accessibilità */
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    outline: 2px solid var(--accent-color, #5d9090); /* Esempio di outline per focus */
    outline-offset: 2px;
  }
  
  .service-item.active {
    box-shadow: 0 6px 12px rgba(0,0,0,0.2);
  }
  
  .service-icon img {
    width: 128px;
    height: 128px;
    object-fit: contain;
    margin-bottom: 0.5rem;
  }
  
  h2 {
    text-align: center;
    margin-bottom: 2rem;
    color: var(--accent-color, #5d9090); /* Fallback se var non definita */
    font-size: 2.5rem;
  }
  
  h3 {
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
    color: #5d9090;
  }
  
  .description {
    margin-top: 1rem;
    color: var(--text-color, #333); /* Fallback se var non definita */
    font-size: 1.2rem; /* Era 1rem, la metto a 1.2rem come h3 o un po' meno per gerarchia */
    line-height: 1.4;
    text-align: left; /* Spesso le descrizioni lunghe sono più leggibili allineate a sx */
  }
</style>